import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Footer.css'; // create this file

const Footer = () => {
  return (
    <footer className="footer bg-light py-5 w-100">
      <div className="container">
        <div className="d-flex justify-content-between flex-wrap">
          
          {/* Online Shopping */}
          <div className="footer-col">
            <h5 className="text-uppercase mb-3">Online Shopping</h5>
            <ul className="list-unstyled">
              <li><a href="#">Men</a></li>
              <li><a href="#">Women</a></li>
              <li><a href="#">Kids</a></li>
              <li><a href="#">Home & Living</a></li>
              <li><a href="#">Beauty</a></li>
              <li><a href="#">Gift Cards</a></li>
              {/* <li><a href="#">Myntra Insider <span className="text-danger">New</span></a></li> */}
            </ul>
          </div>

          {/* Useful Links */}
          {/* <div className="footer-col">
            <h5 className="text-uppercase mb-3">Useful Links</h5>
            <ul className="list-unstyled">
              <li><a href="/faq">FAQ</a></li>
              <li><a href="/policy_footer">Privacy Poilcy</a></li>
              <li><a href="/security">Security</a></li>
              <li><a href="shipping_policy">Shipping Poilcy</a></li>
              <li><a href="cancel_policy">Cancellation & Return Poilcy</a></li>
              <li><a href="refresal">Grievance Redressal</a></li>
              <li><a href="contact-footer">Contact Us</a></li>
              <li><a href="#">Returns</a></li>
              <li><a href="#">Track Order</a></li>
              <li><a href="#">Careers</a></li>
            </ul>
          </div> */}

              <div className="footer-col">
            <h5 className="text-uppercase mb-3">About</h5>
            <ul className="list-unstyled">
              <li><a href="/about">About Us</a></li>
              <li><a href="/story">Stories</a></li>
              <li><a href="#">Careers</a></li>
              <li><a href="/contact-footer">Contact</a></li>
              {/* <li><a href="#">Beauty</a></li>
              <li><a href="#">Gift Cards</a></li>
              <li><a href="#">Myntra Insider <span className="text-danger">New</span></a></li> */}
            </ul>
          </div>
            
            <div className="footer-col">
            <h5 className="text-uppercase mb-3">Help</h5>
            <ul className="list-unstyled">
              <li><a href="/PaymentsPage">Payment</a></li>
              <li><a href="/shipping_policy">Shipping</a></li>
              <li><a href="/faq">FAQ</a></li>
              {/* <li><a href="#">Home & Living</a></li>
              <li><a href="#">Beauty</a></li>
              <li><a href="#">Gift Cards</a></li>
              <li><a href="#">Myntra Insider <span className="text-danger">New</span></a></li> */}
            </ul>
          </div>

              <div className="footer-col">
            <h5 className="text-uppercase mb-3">Consumer Policy</h5>
            <ul className="list-unstyled">
              <li><a href="/TermsOfUse">Terms of use</a></li>
                <li><a href="/policy_footer">Privacy</a></li>
              <li><a href="/security">Security</a></li>
              <li><a href="/cancel_policy">Cancellation and Return Policy</a></li>
               <li><a href="/refresal">Grievance Redressal</a></li>
               <li><a href="#">Sitemap</a></li>
             
              {/* <li><a href="#">Gift Cards</a></li>
              <li><a href="#">Myntra Insider <span className="text-danger">New</span></a></li> */}
            </ul>
          </div>
          {/* App & Social */}
          <div className="footer-col">
            <h6>Keep in touch</h6>
            <div className="social-links">
              <a href="#"><i className="fab fa-facebook-f"></i></a>
              <a href="#"><i className="fab fa-twitter"></i></a>
              <a href="#"><i className="fab fa-instagram"></i></a>
              <a href="#"><i className="fab fa-youtube"></i></a>
            </div>
          </div>

          {/* Promise Section */}
          {/* <div className="footer-col">
            <div className="footer-promise d-flex align-items-center mb-3">
              <img src="https://constant.myntassets.com/web/assets/img/6c3306ca-1efa-4a27-8769-3b69d16948741574602902452-original.png" alt="" width="50" className="me-2" />
              <div>
                <strong>100% ORIGINAL</strong>
                <div>guarantee for all products at myntra.com</div>
              </div>
            </div>
            <div className="footer-promise d-flex align-items-center">
              <img src="https://constant.myntassets.com/web/assets/img/ef05d6ec-950a-4d01-bbfa-e8e5af80ffe31574602902427-30days.png" alt="" width="50" className="me-2" />
              <div>
                <strong>Return within 7 days of receiving your order.</strong>
                <div>of receiving your order</div>
              </div>
            </div>
          </div> */}
     
        </div>
      </div>
      <div className="text-center mt-4">
       ©2025-2026 Garshya.com
   </div>
    </footer>
  );
};

export default Footer;
